(() => {
  if (customElements.get('kq-collection-controls')) return;

  class CollectionControls extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-filter-open]');

      if (this.dialog && typeof this.dialog.showModal === 'function') {
        this.dialog.append(this.querySelector('[data-filter-panel]'));
        this.querySelector('[data-filter-fallback]').hidden = true;
        this.trigger.hidden = false;
        const close = this.querySelector('[data-filter-close]');
        close.hidden = false;
        this.trigger.addEventListener('click', () => {
          if (this.dialog.open) return;
          this.previousOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          this.dialog.showModal();
          this.trigger.setAttribute('aria-expanded', 'true');
          close.focus();
        });
        close.addEventListener('click', () => this.closeDrawer());
        this.dialog.addEventListener('cancel', event => {
          event.preventDefault();
          this.closeDrawer();
        });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
            this.closeDrawer();
          }
        });
        this.dialog.addEventListener('close', () => {
          if (!this.dialog.open && this.previousOverflow !== undefined) this.restorePage();
        });
      }

      this.querySelectorAll('[data-collection-form]').forEach(form => {
        form.addEventListener('submit', event => {
          event.preventDefault();
          if (!form.reportValidity()) return;
          const url = new URL(form.action);
          url.search = window.location.search;
          const sorting = form.hasAttribute('data-sort-form');
          for (const key of [...url.searchParams.keys()]) {
            if ((!sorting && key.startsWith('filter.')) || key === 'sort_by' || key === 'page') url.searchParams.delete(key);
          }
          for (const [key, value] of new FormData(form)) {
            if (value !== '' && (!sorting || key === 'sort_by')) url.searchParams.append(key, value);
          }
          window.location.assign(url.href);
        });
      });

      const sort = this.querySelector('[data-sort-form]');
      if (sort) {
        sort.querySelector('[data-sort-submit]').hidden = true;
        sort.querySelector('select').addEventListener('change', () => sort.requestSubmit());
      }

      const range = this.querySelector('[data-price-range]');
      if (range) {
        const min = range.querySelector('[data-price-min]');
        const max = range.querySelector('[data-price-max]');
        const error = range.querySelector('[data-price-error]');
        const validate = () => {
          const invalid = min.value !== '' && max.value !== '' && min.valueAsNumber > max.valueAsNumber;
          max.setCustomValidity(invalid ? error.textContent : '');
          max.setAttribute('aria-invalid', String(invalid));
          error.hidden = !invalid;
        };
        range.addEventListener('input', validate);
        validate();
      }

      this.querySelectorAll('[data-category-link]').forEach(link => {
        const url = new URL(link.href);
        const current = new URL(window.location.href);
        // A category opens its own assortment and default sort, while retaining preview context.
        for (const key of ['preview_theme_id', 'view', '_fd', 'pb']) {
          if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
        }
        link.href = url.href;
      });

      this.querySelectorAll('[data-filter-clear], [data-filter-remove]').forEach(link => {
        const url = new URL(link.href);
        const current = new URL(window.location.href);
        for (const key of new Set(current.searchParams.keys())) {
          if (key === 'page' || key === 'sort_by' || key.startsWith('filter.')) continue;
          url.searchParams.delete(key);
          current.searchParams.getAll(key).forEach(value => url.searchParams.append(key, value));
        }
        link.href = url.href;
      });
    }

    closeDrawer() {
      this.dialog.close();
      this.restorePage();
    }

    restorePage() {
      this.trigger.setAttribute('aria-expanded', 'false');
      if (this.previousOverflow !== undefined) {
        document.body.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
      if (this.isConnected) this.trigger.focus();
    }

    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        this.restorePage();
      }
    }
  }

  customElements.define('kq-collection-controls', CollectionControls);
})();
